import { Route } from '@angular/router';
import { InitialDataResolver } from 'app/app.resolvers';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { NoAuthGuard } from 'app/core/auth/guards/noAuth.guard';
import { LayoutComponent } from 'app/layout/layout.component';
import { HasRoleGuard } from './core/auth/guards/hasRole.guard';
import { HasUserRoleGuard } from './core/auth/guards/hasUserRole.guard';

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [
    { path: '', pathMatch: 'full', redirectTo: 'monitor' },
    // { path: 'signed-in-redirect', pathMatch : 'full', redirectTo: 'monitor'},

    // {
    //     path: 'signed-in-redirect',
    //     canMatch: [HasRoleGuard],
    //     data: {
    //         expectedRoles: ['ROLE_ADMIN', 'ROLE_SUPER_USER', 'ROLE_GENERAL_MANAGER', 'ROLE_MANAGER']
    //     },
    //     children: [
    //         { path: '', pathMatch: 'full', redirectTo: 'dashboard' }
    //     ]
    // },

    {
        path: 'signed-in-redirect',
        canMatch: [HasUserRoleGuard],
        data: {
            expectedRoles: ['ROLE_USER', 'ROLE_MANAGER'],
        },
        children: [{ path: '', pathMatch: 'full', redirectTo: 'dashboard' }],
    },

    // Redirect empty path to '/example'
    // {path: '', pathMatch : 'full', redirectTo: 'dashboard'},

    // Redirect signed-in user to the '/example'
    //
    // After the user signs in, the sign-in page will redirect the user to the 'signed-in-redirect'
    // path. Below is another redirection for that path to redirect the user to the desired
    // location. This is a small convenience to keep all main routes together here on this file.
    // {path: 'signed-in-redirect', pathMatch : 'full', redirectTo: 'dashboard'},

    // Auth routes for guests
    {
        path: '',
        canMatch: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty',
        },
        children: [
            {
                path: 'sign-in',
                loadChildren: () =>
                    import('app/modules/auth/sign-in/sign-in.module').then(
                        (m) => m.AuthSignInModule
                    ),
            },
        ],
    },

    // Auth routes for authenticated users
    {
        path: '',
        canMatch: [AuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty',
        },
        children: [
            {
                path: 'sign-out',
                loadChildren: () =>
                    import('app/modules/auth/sign-out/sign-out.module').then(
                        (m) => m.AuthSignOutModule
                    ),
            },
        ],
    },

    // Admin routes
    {
        path: '',
        canMatch: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: InitialDataResolver,
        },
        children: [
            // Dashboard route
            {
                path: 'dashboard',
                loadChildren: () =>
                    import('app/modules/dashboard/dashboard.module').then(
                        (m) => m.DashboardModule
                    ),
            },
            // Monitor route
            {
                path: 'monitor',
                loadChildren: () =>
                    import('app/modules/monitor/monitor.module').then(
                        (m) => m.MonitorModule
                    ),
            },
            // Raw data routes
            {
                path: '',
                loadChildren: () =>
                    import('app/modules/raw-data/raw-data.routing').then(
                        (m) => m.RAW_DATA_ROUTES
                    ),
            },
            // Reports routes
            {
                path: '',
                loadChildren: () =>
                    import('app/modules/reports/reports.routing').then(
                        (m) => m.REPORTS_ROUTES
                    ),
            },
            // Admin routes
            {
                path: '',
                loadChildren: () =>
                    import('app/modules/admin/admin.module').then(
                        (m) => m.AdminModule
                    ),
            },

            // 404 & Catch all
            {
                path: '404-not-found',
                pathMatch: 'full',
                loadChildren: () =>
                    import('app/modules/error/error-404/error-404.module').then(
                        (m) => m.Error404Module
                    ),
            },
            { path: '**', redirectTo: '404-not-found' },
        ],
    },
];
